import { render, staticRenderFns } from "./RentalCarList.vue?vue&type=template&id=587cbabf&scoped=true"
import script from "./RentalCarList.vue?vue&type=script&lang=js"
export * from "./RentalCarList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587cbabf",
  null
  
)

export default component.exports